<template>
  <Dialog
    :visible.sync="showDialog"
    :showClose="false"
    :title="$t('game.notice')"
    :confirmText="$t('game.confirm')"
    @confirm="confirm"
    @touchmove.native.prevent
  >
    <!-- 维护公告 -->
    <div class="content" @touchmove.stop v-touchmove>
      {{ $t('game.shopUpdated') }}
    </div>
  </Dialog>
</template>

<script>
export default {
  name: 'WebVipMaintain',
  data() {
    return {
      showDialog: false,
    }
  },
  created() {
    //挂维护
    this.$root.Bus.$on('versionUpdate', () => {
      console.log('=========shopUpdated2')
      this.showDialog = true
    })
  },
  mounted() {},
  methods: {
    confirm() {
      window.location.reload(true)
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  text-align: center;
  padding: 30px 12px;
}
</style>
